import React from 'react';

import BackButton, { Props as BackButtonProps } from 'components/BackButton/BackButton';
import Margin from 'components/Margin/Margin';

type Props = Pick<BackButtonProps, 'onClick'>;

const OnboardingBackButton = ({ onClick }: Props) => (
  <Margin bottom={50}>
    <BackButton onClick={onClick} text="shared.previous" />
  </Margin>
);

export default OnboardingBackButton;
